import Intro from "./scenes/intro/Intro.js";
import Menu from "./scenes/menu/Menu.js";
import Descriptions from "./scenes/descriptions/Descriptions.js";
import MoneyBg from "./scenes/backgroundData/MoneyBg.js";
import StarsBG from "./scenes/backgroundData/StarsBG.js";
import MoneyBagsBG from "./scenes/backgroundData/MoneyBagsBG.js";
import PunkBG from "./scenes/backgroundData/PunkBG.js";
import ShieldBG from "./scenes/backgroundData/ShieldBG.js";
import CloudsBG from "./scenes/backgroundData/CloudsBG.js";
import NinjaBG from "./scenes/backgroundData/NinjaBG.js";
import BeachBG from "./scenes/backgroundData/BeachBG.js";
import HeartsBG from "./scenes/backgroundData/HeartsBG.js";
import CoinsBG from "./scenes/backgroundData/CoinsBG.js";
import CrossBonesBG from "./scenes/backgroundData/CrossBonesBG.js";
import Bonus from "./scenes/bonus/Bonus.js";
import Game_Counting from "./scenes/game/Game_Counting.js";
import Game_Sorting from "./scenes/game/Game_Sorting.js";

export default {
    gameTypes: {SORTING: 0, COUNTING: 1},
    gameType: 1,
    pigType: -1,
    fonts: {comfortaa_light: "comfortaalight", comfortaa_regular: "comfortaaregular", comfortaa_bold: "comfortaabold", saddlebag_regular: "saddlebagregular"},
    startScene: "Intro",
    scenes: [
        {name: "Intro", class: Intro}, 
        {name: "Menu", class: Menu}, 
        {name: "Descriptions", class: Descriptions},
        {name: "Game_Counting", class: Game_Counting},
        {name: "Game_Sorting", class: Game_Sorting},
        {name: "Bonus", class: Bonus}
    ],
    spines: ["Pig", "coin", "dollar"],
    animations: {
        hammerAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 31, frameRate: 60, repeats: false
        },
        explosionAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 25, frameRate: 20, repeats: false
        },
        pennyAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 30, frameRate: 30, repeats: true
        },
        nickelAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 30, frameRate: 30, repeats: true
        },
        dimeAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 30, frameRate: 30, repeats: true
        },
        quarterAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 30, frameRate: 30, repeats: true
        },
        ninjaAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 1, end: 18, frameRate: 30, repeats: false
        },
        oneAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 16, frameRate: 30, repeats: false
        },
        fiveAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 16, frameRate: 30, repeats: false
        },
        tenAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 16, frameRate: 30, repeats: false
        },
        twentyAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 16, frameRate: 30, repeats: false
        },
        fiftyAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 16, frameRate: 30, repeats: false
        },
        hundredAnim: { //note the name is the prefix of all the frames, before the underscore.
            start: 0, end: 16, frameRate: 30, repeats: false
        }
    },
    coinData: {
        quarter: {
            scale: 1, key: "Cent_25", value: .25, sprite: "quarterAnim", tab: "SortTab_25c", offsetY: 20,
            description: "This is a quarter, and it is worth 25 cents. George Washington is the featured president."
        },
        dime: {
            scale: .737, key: "Cent_10", value: .1, sprite: "dimeAnim", tab: "SortTab_10c", offsetY: 85,
            description: "This is a dime, and it is worth ten cents. Franklin D. Roosevelt is the featured president."
        },
        nickel: {
            scale: .873, key: "Cent_5", value: .05, sprite: "nickelAnim", tab: "SortTab_5c", offsetY: 85,
            description: "This is a nickel, and it is worth five cents. Thomas Jefferson is the featured president."
        },
        penny: {
            scale: .784, key: "Cent_1", value: .01, sprite: "pennyAnim", tab: "SortTab_1c", offsetY: 85,
            description: "This is a penny, and it is worth one cent. Abraham Lincoln is the featured president."
        }
    },
    dollarData: {
        1: {
            sprite: "oneAnim", value: 1, offsetY: 95, tab: "SortTab_1d",
            description: "This is a one-dollar bill. George Washington is the featured president.",
        },
        5: {
            sprite: "fiveAnim", value: 5, offsetY: 85, tab: "SortTab_5d",
            description: "This is a five-dollar bill. Abraham Lincoln is the featured president.", 
        },
        10: {
            sprite: "tenAnim", value: 10, offsetY: 90, tab: "SortTab_10d",
            description: "This is a ten-dollar bill. Alexander Hamilton, one of America’s Founding Fathers, is the featured person.", 
        },
        20: {
            sprite: "twentyAnim", value: 20, offsetY: 90, tab: "SortTab_20d",
            description: "This is a twenty-dollar bill. Andrew Jackson is the featured president.", 
        },
        50: {
            sprite: "fiftyAnim", value: 50, offsetY: 90, tab: "SortTab_50d",
            description: "This is a fifty-dollar bill. Ulysses S. Grant is the featured president.", 
        },
        100: {
            sprite: "hundredAnim", value: 100, offsetY: 90, tab: "SortTab_100d",
            description: "This is a one-hundred-dollar bill. Benjamin Franklin, one of America’s Founding Fathers, is the featured person.", 
        },
    },
    backgroundClasses: {
        moneyBG: MoneyBg,
        starsBG: StarsBG,
        moneyBagsBG: MoneyBagsBG,
        punkBG: PunkBG,
        shieldBG: ShieldBG,
        cloudsBG: CloudsBG,
        ninjaBG: NinjaBG,
        beachBG: BeachBG,
        heartBG: HeartsBG,
        coinBG: CoinsBG,
        crossbonesBG: CrossBonesBG
    },
    pigs: {
        flyingPig: {
            bg: "starsBG",
            animation: "Unipig_Intro",
            introSound: "flying_enter",
            crackMask: "uniPig",
            introDelay: 500,
            pigPos: {x: 512, y: 560},
            maskOffset: {x: 34, y: -32}
        },
        thiefPig: {
            bg: "moneyBagsBG",
            animation: "Thief_Intro",
            introSound: "thief_enter",
            introDelay: 600,
            crackMask: "thiefPig",
            pigPos: {x: 512, y: 560},
            maskOffset: {x: 15, y: -10}
        },
        punkPig: {
            bg: "punkBG",
            animation: "Punk_Intro",
            introSound: "punk_enter",
            crackMask: "punkPig",
            pigPos: {x: 495, y: 560},
            maskOffset: {x: 15, y: -52}
        },
        knightPig: {
            bg: "shieldBG",
            animation: "Knight_Intro",
            introSound: "knight_enter",
            introDelay: 200,
            crackMask: "knightPig",
            pigPos: {x: 512, y: 560},
            maskOffset: {x: 21, y: -64}
        },
        pilotPig: {
            bg: "cloudsBG",
            animation: "Pilot_Intro",
            introSound: "pilot_enter",
            introDelay: 500,
            crackMask: "pilotPig",
            pigPos: {x: 512, y: 560},
            maskOffset: {x: 17, y: -30}
        },
        ninjaPig: {
            bg: "ninjaBG",
            animation: "Ninja_Intro",
            introSound: "ninja_enter",
            introDelay: 500,
            crackMask: "ninjaPig",
            pigPos: {x: 512, y: 560},
            maskOffset: {x: 16, y: -4}
        },
        merPig: {
            bg: "beachBG",
            animation: "MerPig_Intro",
            introSound: "mermaid_enter",
            introDelay: 500,
            crackMask: "merPig",
            pigPos: {x: 512, y: 560},
            maskOffset: {x: 24, y: 21}
        },
        princessPig: {
            bg: "heartBG",
            animation: "Princess_Intro",
            introSound: "princess_enter",
            crackMask: "princessPig",
            pigPos: {x: 512, y: 560},
            maskOffset: {x: 17, y: -52}
        },
        richPig: {
            bg: "coinBG",
            animation: "Rich_Intro",
            introSound: "rich_enter",
            crackMask: "richPig",
            pigPos: {x: 512, y: 560},
            maskOffset: {x: 42, y: -60}
        },
        piratePig: {
            bg: "crossbonesBG",
            animation: "Pirate_Intro",
            introDelay: 500,
            introSound: "pirate_enter",
            crackMask: "piratePig",
            pigPos: {x: 512, y: 560},
            maskOffset: {x: 15, y: -39}
        }
    },
    curPig: "thiefPig",
    curBackground: "moneyBG",
    usedPigs: [],
    curProgress: 0,
    numOfLevels: 5,
    denominationTypes: {COINS: 0, DOLLARS: 1, COINS_DOLLARS: 2, CUSTOM: 3},
    denominations: 2,
    customDenominations: null
}

export const GameMode =
{
    // each game mode is a binary bit
    Pennies: parseInt('1', 2),
    Nickels: parseInt('10', 2),
    Dimes: parseInt('100', 2),
    Quarters: parseInt('1000', 2),
    Ones: parseInt('10000', 2),
    Fives: parseInt('100000', 2),
    Tens: parseInt('1000000', 2),
    Twenties: parseInt('10000000', 2),
}

export const Coins = GameMode.Pennies + GameMode.Nickels + GameMode.Dimes + GameMode.Quarters;
export const Bills = GameMode.Ones + GameMode.Fives + GameMode.Tens + GameMode.Twenties;

// counting coin/bill data
export const MaxBillCoinData = {
  maxCoins: 10,
  maxBills: 10,
  maxValue: 200,
  [GameMode.Pennies]: 10,
  [GameMode.Nickels]: 10,
  [GameMode.Dimes]: 10,
  [GameMode.Quarters]: 10,
  [GameMode.Ones]: 10,
  [GameMode.Fives]: 10,
  [GameMode.Tens]: 10,
  [GameMode.Twenties]: 10
}

/**
 * The following functions are used to get the max count of bills and coins.
 * This is done because the max count is a complex data set and it's easier to alter the data using functions.
 */
/**
 * Gets the max bill count.
 */
export function getMaxBills()
{
    return  MaxBillCoinData.maxBills;
}
/**
 * Gets the max coin count.
 */
export function getMaxCoins()
{
    return MaxBillCoinData.maxCoins;
}
export function getMaxBill(bill)
{
    return MaxBillCoinData[bill];
}
export function getMaxCoin(coin)
{
    return MaxBillCoinData[coin];
}